import {Check, Circle} from 'lucide-react'
import styled from 'styled-components'
import React from 'react'
const FieldContainer = styled('div')`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
`

const ContentRow = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`

const IconAndText = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

interface PasswordValidation {
  hasLow: boolean
  hasCap: boolean
  hasSpecialChar: boolean
  hasNumber: boolean
  hasLong: boolean
}

interface IProps {
  validate: PasswordValidation
}

const PasswordRequirements = ({validate}: IProps) => (
  <FieldContainer data-testid="password-requirements-container">
    <div>
      <ContentRow data-testid="password-requirement-lowercase">
        <div>
          {validate.hasLow ? (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              <Check size={12} color="#3DB429" style={{marginRight: 8}} /> One lowercase character
            </div>
          ) : (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              <Circle size={12} color="var(--neutral-600)" style={{marginRight: 8}} /> One lowercase
              character
            </div>
          )}
        </div>
      </ContentRow>
      <ContentRow data-testid="password-requirement-uppercase">
        <span>
          {validate.hasCap ? (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              {' '}
              <Check size={12} color="#3DB429" style={{marginRight: 8}} /> One uppercase character
            </div>
          ) : (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              {' '}
              <Circle size={12} color="var(--neutral-600)" style={{marginRight: 8}} /> One uppercase
              character
            </div>
          )}
        </span>
      </ContentRow>
      <ContentRow data-testid="password-requirement-special-char">
        <span>
          {validate.hasSpecialChar ? (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              <Check size={12} color="#3DB429" style={{marginRight: 8}} />
              One special character
            </div>
          ) : (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              <Circle size={12} color="var(--neutral-600)" style={{marginRight: 8}} />
              One special character
            </div>
          )}
        </span>
      </ContentRow>
      <ContentRow data-testid="password-requirement-number">
        <span>
          {validate.hasNumber ? (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              <Check size={12} color="#3DB429" style={{marginRight: 8}} /> One Number
            </div>
          ) : (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              <Circle size={12} color="var(--neutral-600)" style={{marginRight: 8}} /> One Number
            </div>
          )}
        </span>
      </ContentRow>
      <ContentRow data-testid="password-requirement-length">
        <span>
          {validate.hasLong ? (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              <Check size={12} color="#3DB429" style={{marginRight: 8}} />
              Eight characters minimum
            </div>
          ) : (
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
              <Circle size={12} color="var(--neutral-600)" style={{marginRight: 8}} />
              Eight characters minimum
            </div>
          )}
        </span>
      </ContentRow>
    </div>
  </FieldContainer>
)

export default PasswordRequirements
